(function(algolia) {
  'use strict';
  const render = algolia.externals.render;
  const html = algolia.externals.html;

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
  );

  algolia.render = (template, container, data) => {
    return render(template(html, data), container);
  };

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    openEvent: function(event) {
        event.preventDefault();
        event.stopPropagation();

        console.log($('.modal-algolia'));
        
        $('.modal-algolia').addClass('open');
        $('.modal-algolia').css('display', 'block');
        $('.modal-algolia').html($(event.target).closest('.product-card__content').find('.myModal').html());
        $("body").css("overflow", "hidden");
        document.querySelector('.aa-Input').blur();
    },
    addHandle: function(event) {
        event.preventDefault();
        event.stopPropagation();
        let target = event.target.tagName == 'LI' ? event.target : event.target.parentNode;

        if (target.dataset.productFastadd === "true") {
            let variantId = target.dataset.productVariant;

            const productCardInstance = window.initProductCards(document.querySelector('.product-card'));

            productCardInstance.addItems([{
                id: variantId,
                quantity: 1
            }]);
        }

        setTimeout(function() {
            $('.myModal').css('display', 'none');
            $(event.target).closest('.product-card__content').find('.myModal').removeClass('open');
            $('.aa-DetachedCancelButton').click();
        }, 1500);
        $("body").css("overflow", "auto");
    },
    displayPrice: function displayPrice(item, distinct) {
      if (distinct) {
        var min = item.variants_min_price;
        var max = item.variants_max_price;
        if (min !== max) {
          return  formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formatPrice(item.price);
    },
    displayStrikedPrice: function displayStrikedPrice(price, compare_at_price) {
      const comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
      if (comparing) { return formatPrice(compare_at_price) }
    },
    displayDiscount: function displayDiscount(price, compare_at_price, price_ratio) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      const discount_ratio = 1.0 - price_ratio;
      if (comparing) { return `- ${Math.floor(discount_ratio * 100)} %`}
    },
    instantsearchLink: function instantsearchLink(hit) {
      const addVariantId = !hit._distinct && hit.objectID !== hit.id;
      return (
        '/products/' +
        hit.handle +
        (addVariantId ? '?variant=' + hit.objectID : '')
      );
    },
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title;
      if (
        !distinct &&
        variant_title &&
        variant_title !== 'Default Title' &&
        variant_title !== 'Default'
      ) {
        res += ' (' + variant_title + ')';
      }

      return escapeHtml(res);
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = ' ';
      if (
        !distinct &&
        item.variant_title &&
        item.variant_title !== 'Default Title' &&
        item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex){
      if (!hex) return ``;
      if(hex.length== 4){
        hex = hex.substring(1).replace(/./g, '$&$&')
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    getVariants: async function getVariants(productId, handle) {
      
      return new Promise(function (resolve, reject) {
        if (!productId) {
          reject(new Error("No productId provided"));
          return;
        }
    
        var url_2 = `${window.location.origin}/products/${productId}?view=${handle}`;
        
        $.ajax({
          method: "GET",
          url: url_2,
          headers: {
            'Content-Type': 'application/json'
          },
          success: function (data) {
            //console.log("here data fetch", data);
            resolve(data);
          },
          error: function (error) {
            console.error("Error fetching product", error);
            reject(error);
          }
        });
      });

    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      var image = _distinct ? item.product_image : item.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    index_suffix: (function () {
      const ALGOLIA_MARKET_KEY = 'algolia_market';
      let cache_suffix = '';
      let isMemoized = false;

      return async function memorizedIndexSuffix() {
        if (isMemoized) return cache_suffix;

        if (algolia.config.markets_indexing_enabled && algolia.config.markets_mapping?.length) {
          // Check if market has changed, if changed, update market
          let shouldCheckMarketIndex = true;
          try {
            const marketStorage = JSON.parse(localStorage.getItem(ALGOLIA_MARKET_KEY) || '{}');
            
            if (
              marketStorage.id == algolia.shopify.market.id && 
              marketStorage.locale == algolia.shopify.market.language.shop_locale.locale
            ) {
              cache_suffix = marketStorage.suffix ? `_${marketStorage.suffix}` : '';
              shouldCheckMarketIndex = false;
              isMemoized = true;
            } 
          } catch (e) {
            localStorage.removeItem(ALGOLIA_MARKET_KEY);
            cache_suffix = '';
            isMemoized =true;
          }
          
          if(shouldCheckMarketIndex) {
            try {
              // key = {market_id}_{market_language}
              const key = `${algolia.shopify.market.id}_${algolia.shopify.market.language.shop_locale.locale}`;
              const market = algolia.config.markets_mapping.find(market => market.key === key);
              if(market) {
                const indexSuffix = market.suffix ? `_${market.suffix}` : '';

                // indexName = {prefix}_{type}_{market_title}_{language_code}
                const indexName = `${algolia.config.index_prefix}products${indexSuffix}`;
                const index = algolia.searchClient.initIndex(indexName);

                await index.search({ analystics: false, page: 1, hitsPerPage: 1 })
                cache_suffix = indexSuffix;
                localStorage.setItem(ALGOLIA_MARKET_KEY, JSON.stringify(market));
                isMemoized = true;
              }
            } catch (e) {
              localStorage.removeItem(ALGOLIA_MARKET_KEY);
              cache_suffix = '';
              isMemoized = true;
            }
          }
          return cache_suffix;
        }
        else {
          return cache_suffix;
        }
      }
    })(),
  };

  algolia.config.index_suffix = algolia.helpers.index_suffix();

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = function(item) {
        var image = item.distinct ? item.product_image : item.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    };
  });
})(window.algoliaShopify);
